export default __webpack_public_path__ + "static/amazon-fe546c748e210a17a388fdb81c94d469.png";